import { PaginateResponse } from "./paginate-response.models";

export interface PermissionsUser{
  applicationId: string;
  permissionId: number;
  description: string;
  operations: PermissionOperation[];
}

export interface PermissionOperation{
  applicationId: string;
  permissionId: number;
  operationId: string;
}


export interface ResponseLoginUser{
  statusCode: string;
  user: User;
  permissions: PermissionUser[];
  roles: RolUser[]
}

export interface User{
  id: number;
  username: string;
  firstName: string;
  lastName: string;
  token: TokenUser;
  language: string;
  isAdmin: boolean;
  speciality?: Speciality;
  externalId?: string;
  category?: string;
  managerSocieties?: string[];
}

export interface UserCreate {
  active: boolean;
  admin: boolean;
  avatarUrl?: string;
  category?: string;
  externalId?: string;
  firstName: string;
  langId?: string;
  lastName: string;
  password: string;
  pronounType?: string;
  specialityId?: number;
  username: string;
}

export interface UserUpdate {
  id?: number;
  username?: string;
  active?: boolean;
  admin?: boolean;
  avatarUrl?: string;
  category?: string;
  contactDetails?: ContactDetails[];
  externalId?: string;
  firstName?: string;
  fiscalData?: FiscalData;
  langId?: string;
  lastName?: string;
  password?: string;
  permissions?: PermissionRQ[];
  roles?: RolRQ[];
  pronounType?: string;
  updateOAuthUser?: boolean;
  specialityId?: number;
}

export interface UserDetailResponse {
  users: UserDetail[],
  paginateResponse: PaginateResponse
}

export interface UserDetail {
  id: number;
  admin?: boolean;
  active?: boolean;
  pronounType?: string;
  firstName?: string;
  lastName?: string;
  langId?: string;
  contactDetails?: ContactDetails[];
  specialityId?: number;
  externalId?: string;
  username?: string;
  userName?: string;
  fiscalData?: FiscalData;
  category?: any;
  roles?: RolUser[];
  permissions?: PermissionUser[];
}

export interface UserFilters {
  username?: string;
  firstname?: string,
  lastname?: string;
  active?: boolean;
}
export interface UserQueryFilter {
  paginateRequest: PaginateRequest;
  userFilter?: UserFilters;
}

export interface PaginateRequest {
  limit: number;
  offset: number;
}
export interface TokenUser{
  scope: string;
  jti: string;
  access_token: string;
  token_type: string;
  expires_in: number;
  expired: any;
}
export interface RequestRestPasswordDto{
  message: string,
}

export interface Speciality{
  active: boolean;
  description: string;
  specialityId: number;
  selected?: boolean;
}
export interface RolRQ {
  statusCode?: string;
  roles: RolUser[];
}
export interface RolUser {
  id: number;
  name: string;
  description: string;
  permissions: PermissionUser[]
}
export interface PermissionRQ {
  statusCode?: string;
  permissions: PermissionUser[];
}
export interface PermissionUser {
  applicationId: string;
  id: number;
  description: string;
  operations: OperationUser[];
}

export interface OperationUser {
  applicationId?: string;
  operationId: string;
}
export interface SelectionItem {
  id: string;
  description: string;
}


export interface UserDetailResponse {
  users: UserDetail[],
  paginateResponse: PaginateResponse
}

export interface ContactDetails {
  active: boolean;
  contactType: string;
  id?: number;
  order: number;
  userId?: boolean;
  value: string;
}

export interface FiscalData {
  address?: string;
  countryDivisionId?: string;
  countryId: string;
  destinationId?: number;
  documentNumber: string;
  documentType: string;
  fiscalName: string;
  postalCode?: string;
  roadTypeId?: string;
}

export enum ContactType {
  PHONE = "P",
  MOBILE_PHONE = "C",
  FAX = "F",
  MAIL = "M",
  URL = "U"
}

export enum PronounTypes {
  MISTER = "MR",
  MISS = "MS",
}

export enum ActionContext {
  PROFILE = "myProfile"
}